import { Root, Trigger } from '@radix-ui/react-dialog';

import { DialogContent } from './DialogContent';
import { DialogDescription } from './DialogDescription';
import { DialogFooter } from './DialogFooter';
import { DialogHeader } from './DialogHeader';
import { DialogTitle } from './DialogTitle';

/**
 * @deprecated Use `Dialog` from `@/modus/Dialog` instead.
 */
export const Dialog = Root as typeof Root & {
  Header: typeof DialogHeader;
  Title: typeof DialogTitle;
  Description: typeof DialogDescription;
  Content: typeof DialogContent;
  Trigger: typeof Trigger;
  Footer: typeof DialogFooter;
};

Dialog.Title = DialogTitle;
Dialog.Header = DialogHeader;
Dialog.Description = DialogDescription;
Dialog.Content = DialogContent;
Dialog.Trigger = Trigger;
Dialog.Footer = DialogFooter;
